import { lazy } from 'react';
const Auth = JSON.parse(localStorage.getItem('user'));

// ** Merge Routes
const unProtectedRoutes = [
  {
    path: '/home',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN', 'AGENT'],
    },
  },
  {
    path: '/',
    meta: {
      authRoute: true,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN', 'AGENT'],
    },
  },
  {
    path: '/todos',
    meta: {
      authRoute: true,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN', 'AGENT'],
    },
    exact: true,
    appLayout: true,
    className: 'todo-application',
  },
  {
    path: '/todo/:filter',
    appLayout: true,
    exact: true,
    className: 'todo-application',
    meta: {
      navLink: '/todo'
    }
  },
  {
    path: '/todo/tag/:tag',
    appLayout: true,
    className: 'todo-application',
    meta: {
      navLink: '/todo'
    }
  },
  // {
  //   path: '/redemption-code',
  //   layout: 'BlankLayout',
  //   meta: {
  //     authRoute: Auth ? false : true,
  //     role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN', 'AGENT'],
  //   },
  // },
  {
    path: '/signup/',
    layout: 'BlankLayout',
    meta: {
      authRoute: Auth ? false : true,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN', 'AGENT'],
    },
  },
  {
    path: '/forget-password/',
    layout: 'BlankLayout',
    meta: {
      authRoute: Auth ? false : true,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN', 'AGENT'],
    },
  },
  {
    path: '/reset-password/:resetToken',
    layout: 'BlankLayout',
    meta: {
      authRoute: Auth ? false : true,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN', 'AGENT'],
    },
  },
  {
    path: '/send-forget-email',
    layout: 'BlankLayout',
    meta: {
      authRoute: Auth ? false : true,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN', 'AGENT'],
    },
  },
  {
    path: '/reset-password-success',
    layout: 'BlankLayout',
    meta: {
      authRoute: Auth ? false : true,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN', 'AGENT'],
    },
  },
  {
    path: '/tickets',
    meta: {
      authRoute: Auth ? true : false,
      role: ['SUPER_ADMIN', 'SUB_ADMIN'],
    },
  },
  {
    path: '/leads',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN', 'AGENT'],
    },
  },
  {
    path: '/chats',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN', 'AGENT'],
    },
  },
  {
    path: '/setting',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN'],
    },
  },
  {
    path: '/bots',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN'],
    },
  },
  {
    path: `/bot/:id/questions`,
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN'],
    },
  },
  {
    path: '/bot/:id/question/create',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN'],
    },
  },
  {
    path: '/bot/:id/question/:question/edit',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN'],
    },
  },
  {
    path: '/bot/question/trainings',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN'],
    },
  },
  {
    path: '/users',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN'],
    },
  },
  {
    path: '/user/admins',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN'],
    },
  },
  {
    path: '/integrations/deploy',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN'],
    },
  },
  {
    path: '/integrations/slack',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN'],
    },
  },
  {
    path: '/integrations/hubbspot',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN'],
    },
  },
  {
    path: '/welcome',
    layout: 'BlankLayout',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN', 'AGENT'],
    },
  },
  {
    path: '/smart-assign',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN'],
    },
  },
  {
    path: '/meetings',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN', 'AGENT'],
    },
  },
  {
    path: '/questions',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN'],
    },
  },
  {
    path: '/blogs',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN'],
    },
  },
  {
    path: '/error',
    layout: 'BlankLayout',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN', 'AGENT'],
    },
  },
  {
    path: '/wizard',
    layout: 'BlankLayout',
    meta: {
      authRoute: Auth ? false : true,
      role: ['ADMIN'],
    },
  },
  {
    path: '/code',
    meta: {
      authRoute: Auth ? true : false,
      role: ['SUPER_ADMIN'],
    },
  },
  {
    path: '/reporting',
    meta: {
      authRoute: Auth ? true : false,
      role: ['ADMIN', 'SUPER_ADMIN', 'SUB_ADMIN'],
    },
  },
];

const Routes = [];
unProtectedRoutes.map((route) => {
  Routes.push(route);
});

export { Routes };
